<template>
  <div class="add-task" v-loading="loading">
    <PageBar>
        <div class="task-bar">
            <i class="el-icon-back"/>
            <span v-matomo="{behaviorCategory: '广告批量调控', event: '点击',  name: isCopy?'复制任务(返回)':'添加任务(返回)', value: {} }" class="colse" @click="()=>toListPage(false)">取消</span>
            |
            <span class="add">添加任务</span>
            <el-popover
                placement="right-start"
                title="存在以下问题点，请检查修改后重试："
                width="400"
                trigger="manual"
                v-model="popoverVisible">
                    <div class="tip-list">
                        <div v-for="(item, index) in errValidList" :key="index">
                            <template v-if="Array.isArray(item)">
                                <div v-for="(v, i) in item" :key="i">
                                    <span>{{v.name}}</span>
                                    <div class="pl10" v-for="child in (v.child || [])" :key="child.id">{{ child.name }}</div>
                                </div>
                            </template>
                            <template v-else>
                                {{index+1}}、{{item}}
                            </template>
                        </div>
                        <div class="btn"><el-button @click="popoverVisible = !popoverVisible" type="primary" size="mini"><span>关闭</span></el-button></div>
                    </div>
                    <el-button  v-matomo="{behaviorCategory: '广告批量调控', event: '点击',  name: isCopy?'复制任务(提交)':'添加任务(提交)', value: {} }" slot="reference" type="primary" @click="()=>handleSubmitClick()" :loading="saveLoading"><span class="save">提交</span></el-button>
            </el-popover>
        </div>
    </PageBar>
    <div class="task-form" v-if="!loading">
        <TitleItem>媒体</TitleItem>
        <PlatForm 
            ref="plat-form" 
            class="form-layout" 
            :platList="platList" 
            :platId.sync="platId" 
            :defaultFormData="defPlatFormData"
            v-bind="configFormAttrs"
        />
       <TitleItem>筛选</TitleItem> 
        <ScreenForm 
            ref="screen-form" 
            class="form-layout" 
            :platId="platId" 
            :defaultFormData="defScreenFormData"
            :screenType.sync="screenType"
            v-bind="configFormAttrs"
        />
        <TitleItem>操作</TitleItem> 
        <ActionForm 
            ref="action-form" 
            class="form-layout" 
            :screenType="screenType"
            :platId="platId" 
            :configAutn="configAutnData" 
            :defaultFormData="defActionFormData"
            v-bind="configFormAttrs"
        />
    </div>
    </div>
</template>

<script>
import PageBar from '@/components/PageBar'
import PlatForm from './platForm.vue'
import ActionForm from './actionForm.vue'
import ScreenForm from './screenForm'
import TitleItem from './titleItem.vue'
import { 
    getAdjustmentConfigApi, saveAdjustmentDataApi, copyAdjustmentDataApi, saveCopyAdjustmentDataApi,
    preSaveAdjustmentDataApi,
    preSaveCopyAdjustmentDataApi
    } from '@/api'
import { 
    PLAT_TYPE, SCREEN_TYPE, ACTION_TYPE_DATA, ACTION_TYPE_REVERSAL_DATA, ACTION_TYPE, LIMIT_TYPE,
    GROUP_TYPE ,ADJUST_TYPE, ADJUST_TYPE_LIST, ADJUST_VALUE_TYPE, ADJUST_VALUE_TYPE_LIST, SCREEN_TYPE_LIST
} from './constant'
import { messageTipModal, messageTabelModal } from '../../modal'
import _ from 'lodash'
export default {
    components: { PageBar, PlatForm, TitleItem, ActionForm, ScreenForm },
    provide() {
        return {
            validFormItem: (...args)=>this.handleValidFormItem(...args)
        }
    },
    props: {
        query: {
            type: Object,
            default: ()=> ({}),
        }
    },
    data() {
        return {
            platId: PLAT_TYPE.OPPO,//默认 和 选择的媒体
            screenType: SCREEN_TYPE.PLAN,
            configFormAttrs: {
                labelWidth: "100px",
                labelPosition: "left"
            },
            errValidList: [],
            saveLoading: false,
            popoverVisible: false,
            loading: false,
            platList: [
                { value: PLAT_TYPE.OPPO, label: 'OPPO' },
                { value: PLAT_TYPE.VIVO, label: 'vivo' },
                { value: PLAT_TYPE.HW, label: '华为' },
                { value: PLAT_TYPE.HW_ADS, label: '华为Ads' },
                { value: PLAT_TYPE.RY, label: '荣耀' },
                { value: PLAT_TYPE.MI, label: '小米' },
            ],
            configAutnData: {},
            defPlatFormData: {
                plat_id: PLAT_TYPE.OPPO
            },
            defActionFormData: {
                group: GROUP_TYPE.PLAN,//操作层级
                groupItemList: [],//操作项
                state: '0',//开关
                plannedBudgetType: LIMIT_TYPE.LIMIT,//是否限制计划预算
                plannedBudget: null,// 计划预算
                plannedBudgetAdjustType: ADJUST_TYPE.ADJUST,//预算类型
                plannedBudget: null,// 预算
                plannedBudgetValueType: ADJUST_VALUE_TYPE.FIXED,// 预算值类型
                plannedBudgetMax: null,// 预算上限

                releaseDateType: LIMIT_TYPE.LIMIT,// 是否限制投放日期
                releaseDate: null,// 投放日期
                releaseOnlyDate: null,// 指定开始日期

                releasePeriodType: LIMIT_TYPE.LIMIT,// 投放时段
                releasePeriod: new Array(336).fill('0').join(''),// 投放时段
                basePriceAdjustType: ADJUST_TYPE.INCREASE,// 基准价调整类型
                basePriceValueType: ADJUST_VALUE_TYPE.FIXED,// 基准价调整值类型
                basePrice: null,// 基准价
                basePriceMax: null,// 基准价上限

                secondPriceAdjustType: ADJUST_TYPE.INCREASE,// 二阶出价调整类型
                secondPriceValueType: ADJUST_VALUE_TYPE.FIXED,// 二阶出价调整值类型
                secondPrice: null,// 二阶出价
                secondPriceMax: null,// 二阶出价上限
                thirdPriceAdjustType: ADJUST_TYPE.INCREASE,// 三阶出价调整类型
                thirdPriceValueType: ADJUST_VALUE_TYPE.FIXED,// 三阶出价调整值类型
                thirdPrice: null,// 三阶出价
                thirdPriceMax: null,// 三阶出价上限
            },
            defScreenFormData: {
                screenType: SCREEN_TYPE.PLAN,
                checkList: []
            },
        }
    },
    computed:{
        isCopy(){
            return !!(this.query?.id);
        }
    },
    created() {
        this.getDefFormData()
        // this.getFormConfig()
    },
    methods: {
        async getDefFormData() {
            try {
                this.loading = true;
                await this.getFormConfig();
                await this.copyAdjustmentData();
            } catch (error) {
                console.log('获取表单配置失败', error);
                this.$message.error(error.info || error.message)
            }finally {
                this.loading = false;
            }
        },
        async getFormConfig() {
            const result= await getAdjustmentConfigApi();
            const data = result.data.data;
            const platIds = Object.keys(data).map(v=>+v);
            this.platList = this.platList.filter(v=>platIds.includes(v.value));
            
            const  configAutn = data;
            this.configAutnData = configAutn;
            console.log('----', this.configAutnData)
            this.checkPlat([...platIds]);
            this.defPlatFormData.plat_id = this.platId;
        },
        async copyAdjustmentData() {
            const { id } = this.query || {};
            if (!id) {
                return;
            }
            const params = {
                task_id:  id
            }
            const { data } =  await copyAdjustmentDataApi(params);
            this.platId = +data.plat_id;
            const defPlatFormData = {
                plat_id: +data.plat_id,
            };
            const operation_items_json = JSON.parse(data.operation_items);
            const getData = (type)=> {
                return operation_items_json[ACTION_TYPE_DATA[type]];
            };
            // 判定不限  使用空字符串   因为不限传给后端的是空字符串
            const defActionFormData = {
                group: data.operation_level,//操作层级
                groupItemList: Object.keys(operation_items_json).map(v=>ACTION_TYPE_REVERSAL_DATA[v]),//操作项
                state: getData(ACTION_TYPE.STATE) || '0',//开关
                releasePeriodType:  getData(ACTION_TYPE.RELEASE_PERIOD) !=='' ? LIMIT_TYPE.LIMIT : LIMIT_TYPE.NO_LIMIT,// 是否限制投放时段
                releasePeriod: getData(ACTION_TYPE.RELEASE_PERIOD) ?  getData(ACTION_TYPE.RELEASE_PERIOD) : new Array(336).fill('0').join(''),// 投放时段
            };

            // releaseDateType:  getData(ACTION_TYPE.RELEASE_DATE) !=='' ? LIMIT_TYPE.LIMIT : LIMIT_TYPE.NO_LIMIT,// 是否限制投放日期
            // releaseDate: getData(ACTION_TYPE.RELEASE_DATE) && getData(ACTION_TYPE.RELEASE_DATE).split('/'),// 投放日期

            const releaseDateData = getData(ACTION_TYPE.RELEASE_DATE);
            if(!releaseDateData) {
                defActionFormData.releaseDateType = LIMIT_TYPE.LIMIT;
                defActionFormData.releaseDate = [];
                defActionFormData.releaseOnlyDate= null;
            }else if(releaseDateData && releaseDateData.indexOf('/')>-1){
                defActionFormData.releaseDateType = LIMIT_TYPE.LIMIT;
                defActionFormData.releaseDate = releaseDateData.split('/');
                defActionFormData.releaseOnlyDate= null;
            }else {
                defActionFormData.releaseDateType = LIMIT_TYPE.LIMIT_DATE;
                defActionFormData.releaseOnlyDate = releaseDateData;
                 defActionFormData.releaseDate = null;
            }
            const plannedBudgetData = getData(ACTION_TYPE.PLANNED_BUDGET);
            const plannedBudgetType = ( plannedBudgetData && typeof plannedBudgetData === 'object') ? LIMIT_TYPE.LIMIT : LIMIT_TYPE.NO_LIMIT;// 是否限制计划预算
            defActionFormData.plannedBudgetType = plannedBudgetType;
            if(plannedBudgetType === LIMIT_TYPE.LIMIT) {
                // console.log(plannedBudgetData, 'plannedBudgetType');
                defActionFormData.plannedBudgetAdjustType = plannedBudgetData.operator;
                defActionFormData.plannedBudgetValueType = plannedBudgetData.type;
                defActionFormData.plannedBudget = plannedBudgetData.value;
                defActionFormData.plannedBudgetMax = plannedBudgetData.boundary;
            }else {
                defActionFormData.plannedBudgetAdjustType = ADJUST_TYPE.ADJUST;
                defActionFormData.plannedBudgetValueType = ADJUST_VALUE_TYPE.FIXED;
                defActionFormData.plannedBudget =null;
                defActionFormData.plannedBudgetMax = null;
            };
            [ACTION_TYPE.BASE_PRICE,ACTION_TYPE.SECOND_PRICE,ACTION_TYPE.THIRD_PRICE].forEach(v=>{
                const data = getData(v);
                if (data) {
                    defActionFormData[`${v}AdjustType`] = data.operator;
                    defActionFormData[`${v}ValueType`] = data.type;
                    defActionFormData[`${v}Max`] = data.boundary;
                    defActionFormData[v] = data.value;
                }else {
                    defActionFormData[`${v}AdjustType`] = ADJUST_TYPE.INCREASE;
                    defActionFormData[`${v}ValueType`] = ADJUST_VALUE_TYPE.FIXED;
                    defActionFormData[`${v}Max`] = null;
                    defActionFormData[v] = null;
                }
               
            })
            const defScreenFormData = {
                screenType: data.search_type,
                checkList: data.target_data,
            };
            this.defPlatFormData = defPlatFormData;
            this.defActionFormData = defActionFormData;
            this.defScreenFormData = defScreenFormData;

        },
        // 设置默认选中的媒体
        checkPlat(ids) {
            const def_plat = this.$store.state.adjustment.def_plat;
            if (!def_plat || !ids.includes(def_plat)) {
                return this.platId = ids[0];
            };
            // 设置成上一次使用的媒体
            this.platId = def_plat;
        },
        handleValidFormItem(info) {
            this.errValidList.push(info);
        },
        async handleSubmitClick(no_valid_data = []) {
            try {
                this.saveLoading = true;
                this.errValidList = [];
                const [ platData, actionData, screenData ] = await Promise.all([
                    this.$refs['plat-form'].validateFn(),
                    this.$refs['action-form'].validateFn(),
                    this.$refs['screen-form'].validateFn(),
                ]);
                const groupData = +actionData.group + 1;
                // console.log(groupData, screenData.search_type, screenData.search_type - groupData);
                const params = {
                        // 媒体
                    plat_id: platData.plat_id,

                    // 操作
                    operation_level: actionData.group,
                    operation_items: actionData.operation_items,

                    // 筛选内容
                    condition: screenData.condition,
                    search_type: screenData.search_type,
                    no_valid_data
                };
                if (this.query?.id) {
                    params.task_id = this.query.id;
                }
                try {
                    if (params.task_id) {
                        await preSaveCopyAdjustmentDataApi(params)
                    }else {
                        await preSaveAdjustmentDataApi(params);
                    };
                    if ( groupData  > screenData.search_type  ) {
                        const groupListData = this.configAutnData[this.platId].groupListData || [];
                        const groupData =  _.find(groupListData, { value: actionData.group })
                        const screenTypeData =  _.find(SCREEN_TYPE_LIST, { value: screenData.search_type })
                        console.log(groupData, screenTypeData, groupListData, SCREEN_TYPE_LIST, actionData.group, screenData.search_type, '21111');
                        const isGen = await this.accountTip(screenTypeData.label, groupData.label);
                        // 取消则不生成任务 games greedy-snake
                        if (!isGen) {
                            return;
                        }
                    };
                    if (params.task_id) {
                        await saveCopyAdjustmentDataApi(params)
                    }else {
                        await saveAdjustmentDataApi(params);
                    }
                    this.$message.success('添加成功');
                    this.$store.commit('adjustment/ADD_DEF_PLAT', params.plat_id);
                    this.toListPage(true);
                   
                } catch (error) {
                    if(error.data.type) {
                        const onSubmit = (type)=> {
                            if(!type) {
                                vm.close();
                                return;
                            }
                            if( isDelete ) {
                                const list = error.data.err_list || [];
                                const delList = error.data.need_to_be_eliminated_ids || []
                                params.condition = _.remove(params.condition, delList.map(v=>v.id));
                                console.log(delList,this.$refs['screen-form'] ,111);
                                delList.forEach(v=>{
                                    this.$refs['screen-form'].handleCheckData( false, { id: v } )
                                })
                                this.handleSubmitClick([ ...params.no_valid_data ])
                            }else {
                                this.handleSubmitClick([ ...params.no_valid_data, error.data.type  ])
                            }
                           vm.close()
                        }
                        const { delete: isDelete } = error.data;
                        const { vm } = messageTabelModal({
                            props: {
                                message: error.info,
                                list: error.data.err_list,
                                onText: isDelete ? '一键剔除并提交' : '继续提交',
                                closeText: '取消'
                            },
                            cbs: { onSubmit }
                        })
                        return
                    }
                    console.log('任务保存失败', error);
                    this.errValidList = [ error.info || error.message ];
                    if (Array.isArray(error.data) && error.data.length) {
                        this.errValidList.push(error.data)
                    }
                     if (Array.isArray(error.data?.err_list) && error.data?.err_list.length) {
                        this.errValidList.push(error.data.err_list)
                    }
                    this.popoverVisible = true;
                }
            } catch (error) {
                console.log(error, '提交验证错误');
                this.popoverVisible = true;
            } finally {
                this.saveLoading = false;
            }
        },
        // 账户任务生成提示
        accountTip(screenType, groupType) {

            return new Promise((resolve, reject)=> {
                const onSubmit = (type)=> {
                    resolve(type)
                    vm.close()
                }
                const { vm } = messageTipModal({
                        props: {
                        message: `提交后按照筛选的${screenType}，现查媒体当前的${groupType}列表，若在提交后创建了新的${groupType}，可能不会被记录到，请注意！`,
                        onText: '已知晓',
                        closeText: '取消'
                    },
                    cbs: { onSubmit }
                })
            })
            
        },
        async toListPage(isSave) {
            if (!isSave) {
                await new Promise((resolve, reject)=> {
                    // 验证是否存在筛选的数据
                    this.$bus.$emit('validSelectData', (selectData, callback)=> {
                        if (!selectData.length) {
                            resolve();
                            return;
                        }
                         this.$confirm('取消后已经修改的内容不会保存，确认要取消吗？', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(resolve).catch(reject);
                    })
                });
            };
            this.$emit('changePage', 'AdBatchAdjustmentPage', {}, isSave)
        }
    }
}
</script>

<style lang="scss" scoped>
.add-task {
    padding-top: 60px;
    min-height: 500px;
}
.task-bar {
    background: #fff;
    height: 44px;
    margin: 0 10px;
    border-radius: 6px;
    border-bottom: 1px solid #e2e2e2;
    padding-left: 10px;
    line-height: 44px;
    font-size: 14px;
    .colse {
        margin-right: 6px;
        cursor: pointer;
    }
    .add {
        font-weight: bold;
        margin-left: 6px;
        margin-right: 30px;
    }
    .save {
        padding: 0 30px;
    }
}
.task-form {
    background: #fff;
    margin: 0 10px;
    padding: 25px 20px;
    border-radius: 6px;
}
.form-layout {
    padding-left: 12px;
}
.tip-list {
    
    max-height: 500px;
    overflow: auto;
  .btn {
    text-align: center;
    margin-top: 12px;
    span {
      padding: 0 12px;
    }
  }
}
</style>
